import * as React from 'react';
import { CircleNotch, Warning } from '@phosphor-icons/react';
import { useToast } from '@fragments-sdk/ui';
import s from './settings.module.scss';

export function AccountDeletionPanel({ isDemoOrg }: { isDemoOrg: boolean }) {
  const { error } = useToast();
  const [confirming, setConfirming] = React.useState(false);
  const [deleting, setDeleting] = React.useState(false);

  if (isDemoOrg) return null;

  async function handleDeleteAccount() {
    setDeleting(true);
    try {
      const response = await fetch('/api/account/delete', { method: 'POST' });
      const body = (await response.json().catch(() => ({}))) as {
        error?: string;
      };

      if (!response.ok) {
        error(
          'Account deletion failed',
          body.error ?? 'Could not delete this account.',
        );
        setDeleting(false);
        return;
      }

      window.location.assign('/sign-in?accountDeleted=1');
    } catch (err) {
      error(
        'Account deletion failed',
        err instanceof Error ? err.message : 'Could not delete this account.',
      );
      setDeleting(false);
    }
  }

  return (
    <div className={s.section} data-danger>
      <p className={s.sectionTitle}>Account</p>
      {!confirming ? (
        <div className={s.dangerRow}>
          <div className={s.dangerInfo}>
            <p className={s.dangerLabel}>Delete account</p>
            <p className={s.dangerDesc}>
              Permanently delete your Fragments Cloud account, owned workspaces,
              repository data, GitHub tokens, API keys, and MCP tokens. GitHub
              repositories and pull requests are left untouched.
            </p>
          </div>
          <button
            type="button"
            className={s.dangerBtn}
            onClick={() => setConfirming(true)}
          >
            Delete account
          </button>
        </div>
      ) : (
        <div className={s.dangerConfirm}>
          <Warning size={16} className={s.dangerConfirmIcon} />
          <p className={s.dangerConfirmText}>
            This permanently removes your Fragments Cloud data and deletes your
            login. This action cannot be undone.
          </p>
          <div className={s.dangerConfirmActions}>
            <button
              type="button"
              className={s.disconnectConfirmBtn}
              data-variant="danger"
              onClick={handleDeleteAccount}
              disabled={deleting}
            >
              {deleting ? (
                <>
                  <CircleNotch size={12} className={s.spinIcon} />
                  Deleting...
                </>
              ) : (
                'Yes, delete my account'
              )}
            </button>
            <button
              type="button"
              className={s.disconnectConfirmBtn}
              onClick={() => setConfirming(false)}
              disabled={deleting}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
